module.exports = __webpack_public_path__ + "img/dolar.be3f5339.svg";